import { useCallback, useState } from "react";

/**
 * Manages sort state for a table column.
 *
 * Clicking the same key toggles direction; clicking a new key resets to ascending.
 *
 * @param {string} initialKey - the column key to sort by on first render
 * @returns {{
 *   sortConfig: { key: string, direction: "ascending"|"descending" },
 *   requestSort: (key: string) => void
 * }}
 */
const useSortConfig = (initialKey) => {
    const [sortConfig, setSortConfig] = useState({
        key: initialKey,
        direction: "ascending"
    });

    const requestSort = useCallback((key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "ascending" ? "descending" : "ascending"
        }));
    }, []);

    return { sortConfig, requestSort };
};

export default useSortConfig;
